var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeaderIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 24,
  viewBox: "0 0 26 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.07806 14.4268C4.21013 13.932 4.91278 13.932 5.04486 14.4268L5.75091 17.0732C5.79707 17.2461 5.9325 17.3816 6.1054 17.4277L8.75189 18.1338C9.24659 18.2659 9.24659 18.9685 8.75189 19.1006L6.1054 19.8066C5.9325 19.8528 5.79707 19.9882 5.75091 20.1611L5.04486 22.8076C4.91278 23.3023 4.21013 23.3023 4.07806 22.8076L3.37201 20.1611C3.32585 19.9882 3.19042 19.8528 3.01751 19.8066L0.37103 19.1006C-0.123677 18.9685 -0.123677 18.2659 0.37103 18.1338L3.01751 17.4277C3.19042 17.3816 3.32585 17.2461 3.37201 17.0732L4.07806 14.4268ZM15.8212 0.53222C15.9964 -0.177401 17.0044 -0.177413 17.1796 0.53222L18.5771 6.19042C18.6394 6.44285 18.8364 6.6408 19.0888 6.70312L24.747 8.0996C25.4566 8.27479 25.4566 9.28379 24.747 9.45898L19.0888 10.8555C18.8365 10.9177 18.6395 11.115 18.5771 11.3672L17.1796 17.0264C17.0044 17.7359 15.9965 17.7359 15.8212 17.0264L14.4238 11.3672C14.3613 11.115 14.1643 10.9177 13.912 10.8555L8.25287 9.45898C7.5437 9.28358 7.54371 8.27502 8.25287 8.0996L13.912 6.70312C14.1645 6.6408 14.3614 6.44285 14.4238 6.19042L15.8212 0.53222Z",
  fill: "url(#paint0_linear_2252_40322)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2252_40322",
  x1: 0,
  y1: 11.5893,
  x2: 57.7155,
  y2: 11.5893,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EB4254"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4585FF"
})))));
export default SvgHeaderIcon;